// React
import React, { useState, useRef, useEffect } from "react";

// React Async
import Async from "react-async";

// Components
import { Typeahead, Highlighter, AsyncTypeahead } from "react-bootstrap-typeahead";

// Internal Libs
import * as EventifyAPI from "../libs/EventifyAPI";

// Style
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead-bs4.css';

const PersonSelectionTypeahead = React.forwardRef((props, ref) => {
  const [isLoading, setIsLoading] = useState(false);
  const [originalPersonArray, setOriginalPersonArray] = useState([]);
  const [apiResponseList, setAPIResponseList] = useState([]);
  const multiple = true;

  var lastKnownValue = "";
  var usingExistingResult = false;

  var personData = [];
  var personMap = {};

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    // TODO: this does not scale well... should be handled server-side
    EventifyAPI.getAllPeople().then( (persons) => {
      setAPIResponseList(persons);
    });
  }

  // Allow hierarchy to call functions on this component
  // the ref might not actually be necessary
  const dropdownNameRef = React.useRef();
  const dropdownEmailRef = React.useRef();

  React.useImperativeHandle(ref, () => ({
    clearFields: () => {
      if (props.type === "name") {
        dropdownNameRef.current.getInstance().clear();
      }
      if (props.type === "email") {
        dropdownEmailRef.current.getInstance().clear();
      }
    },
    getSelectedPersons: () => {
      //
      if (props.type === "name") {
        return {"name": dropdownNameRef.current.getInstance().getInput().value};
      }
      if (props.type === "email") {
        return {"email": dropdownEmailRef.current.getInstance().getInput().value};
      }
    },
    setSelectionByFORCE: (selection, type) => {
      if (selection == null || (typeof selection === "undefined")) {
        return;
      }
      if (type === "email" && props.type === "name") {
        const nameNode = dropdownNameRef.current.getInstance().getInput();
        // dropdownNameRef.current.getInstance().clear();
        if ((typeof selection.name !== "undefined")) {
          nameNode.value = selection.name;
          lastKnownValue = selection.name;
          usingExistingResult = false;
        } else if (selection.customOption == true) {
          // nameNode.value = selection.name;
          // lastKnownValue = selection.name;
          usingExistingResult = false;
        }
      }
      if (type === "name" && props.type === "email") {
        const emailNode = dropdownEmailRef.current.getInstance().getInput();
        // dropdownEmailRef.current.getInstance().clear();
        if ((typeof selection.email !== "undefined")) {
          emailNode.value = selection.email;
          lastKnownValue = selection.email;
          usingExistingResult = false
        } else if (selection.customOption == true) {
          // nameNode.value = selection.name;
          // lastKnownValue = selection.name;
          usingExistingResult = false;
        }
      }
    }
  }));

  function renderMenuItemChildren() {
    return (option, props, index) => {
      return (
        <>
          <div className="highlighter-rows">
            <Highlighter search={props.text}>
              {props.id.toLowerCase().indexOf("name") >= 0 ? option.name : option.email}
            </Highlighter>
          </div>
        </>
      )
    }
  }

  function convertPersonAPIResultToDropdown(data) {
    personData = data;

    var personIdentifiersFlatMap = [];
    for (var idx=0; idx<data.length; idx++) {
      const person = data[idx];
      personMap[person.personid] = person;
      if (props.inListAlready(person.personid) == false) {
        personIdentifiersFlatMap.push(person);
      }
    }

    return (
      <AsyncTypeahead
        isLoading={false}
        ref={props.type === "name" ? dropdownNameRef : dropdownEmailRef}
        id={props.id}
        labelKey={option => `${props.type === "name" ? option.name : ""} ${props.type === "email" ? " " +   option.email : ""}`}
        multiple={props.multiple == null ? false : true}
        options={personIdentifiersFlatMap}
        placeholder={props.title != null ? props.title : "Search for Contact"}
        onSearch={query => {
          //
        }}
        onChange={(selected) => {
          // const richSelection = selected.map( (name, n) => {
          //   return personMap[name];
          // });
          if (props.type === "name" && usingExistingResult == false) {
            const nameNode = dropdownNameRef.current.getInstance().getInput();
            // dropdownNameRef.current.getInstance().clear();
            lastKnownValue = nameNode.value;
          }
          if (props.type === "email" && usingExistingResult == false) {
            const emailNode = dropdownEmailRef.current.getInstance().getInput();
            // dropdownEmailRef.current.getInstance().clear();
            lastKnownValue = emailNode.value;
          }
          usingExistingResult = true;
          props.onUpdate(selected, props.type);
        }}
        onInputChange={ (event) => {
          if (props.type === "name" && usingExistingResult == false) {
            const nameNode = dropdownNameRef.current.getInstance().getInput();
            // dropdownNameRef.current.getInstance().clear();
            lastKnownValue = nameNode.value;
          }
          if (props.type === "email" && usingExistingResult == false) {
            const emailNode = dropdownEmailRef.current.getInstance().getInput();
            // dropdownEmailRef.current.getInstance().clear();
            lastKnownValue = emailNode.value;
          }
          props.onInputChange(lastKnownValue);
        }}
        onFocus={ (event) => {
          if (props.type === "name") {
            const nameNode = dropdownNameRef.current.getInstance().getInput();
            // dropdownNameRef.current.getInstance().clear();
            nameNode.value = lastKnownValue;
          }
          if (props.type === "email") {
            const emailNode = dropdownEmailRef.current.getInstance().getInput();
            // dropdownEmailRef.current.getInstance().clear();
            emailNode.value = lastKnownValue;
          }
        }}
        renderMenuItemChildren={renderMenuItemChildren()}
        type={props.type}
      />
    );
  }

  return (
    <>
      {convertPersonAPIResultToDropdown(apiResponseList)}
    </>
  );
});

export default PersonSelectionTypeahead;
